import styled from 'styled-components';

export const DropdownContainer = styled.div`
  margin-top: 4px;
  width: 100%;
  max-height: 200px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
  z-index: 1000;
  overflow-y: auto;
`;

export const DropdownItem = styled.div`
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;